import React, { PropTypes, Component } from 'react'
import TextInput from 'components/Form/components/TextInput'
import styles from '../../BankTransferDisplayForm.scss'

class AtoForm extends Component {
    static propTypes = {
      form: PropTypes.object.isRequired,
      handleChange: PropTypes.func.isRequired,
      handleFocus: PropTypes.func.isRequired,
      handleValidation: PropTypes.func.isRequired,
      schema: PropTypes.object.isRequired,
    }

    render() {
      const {
        schema, form, handleChange, handleValidation, handleFocus,
      } = this.props
      return (
        <div className={styles.fieldset}>
          <li>
            <TextInput
              {...schema.atoEftCodeNo}
              error={form.atoEftCodeNo.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.atoEftCodeNo.value}
              valid={form.atoEftCodeNo.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.paygNoticeName}
              error={form.paygNoticeName.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.paygNoticeName.value}
              valid={form.paygNoticeName.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.toAccountName}
              disabled
              error={form.toAccountName.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.toAccountName.value}
              valid={form.toAccountName.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.toAccountNumber}
              disabled
              error={form.toAccountNumber.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.toAccountNumber.value}
              valid={form.toAccountNumber.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.bankName}
              disabled
              error={form.bankName.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.bankName.value}
              valid={form.bankName.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.bankAddress}
              disabled
              error={form.bankAddress.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.bankAddress.value}
              valid={form.bankAddress.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.bankCity}
              disabled
              error={form.bankCity.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.bankCity.value}
              valid={form.bankCity.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.bankState}
              disabled
              error={form.bankState.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.bankState.value}
              valid={form.bankState.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.bankCountry}
              disabled
              error={form.bankCountry.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.bankCountry.value}
              valid={form.bankCountry.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.bankZip}
              disabled
              error={form.bankZip.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.bankZip.value}
              valid={form.bankZip.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.amount}
              error={form.amount.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.amount.value}
              valid={form.amount.valid}
            />
          </li></div>
      )
    }
}

export default AtoForm



// WEBPACK FOOTER //
// ./src/views/AccountsAndLoans/components/BankTransfer/AtoForm.js